import { JWT } from "next-auth/jwt";
import { ExtendedJWT, AccountJWTSchema } from "./types";

export const parseJWT = ({ jwt }: { jwt: JWT }): ExtendedJWT => {
  return AccountJWTSchema.parse(jwt);
};
